import PropTypes from "prop-types";

import {
  Box,
  Grid,
  Accordion,
  AccordionItem,
  AccordionButton,
  AccordionPanel,
  AccordionIcon,
  Text,
  GridItem,
} from "@chakra-ui/react";

const InfoCardAccordion = ({
  title,
  flex,
  justify,
  align,
  children,
  subtitle,
  ...props
}) => {
  return (
    <Box
      borderRadius='md'
      borderBottomWidth="1px"
      borderColor="#cacaca"
      overflow="hidden"
      {...props}
    >
      <Accordion defaultIndex={[0]} allowMultiple border="transparent">
        <AccordionItem>
          <h2>
            <Grid templateColumns="repeat(8, 1fr)" gap={6} bgColor='#f5f5f5' borderBottomColor='#1b1c1e' borderBottomWidth='1px' >
              <GridItem w="100%" colSpan={7}>
                <Box flex="1" textAlign="left" p={4}>
                  <Text fontSize="md" color="#1b1c1e" fontWeight="700">
                    {title}
                  </Text>
                </Box>
              </GridItem>
              <AccordionButton>
                <AccordionIcon className="gg-align-right" />
              </AccordionButton>
            </Grid>
          </h2>
          <AccordionPanel color="mutedText" textAlign="justify">
            <Box
              d="flex"
              alignItems={align}
              flexDir={flex}
              justifyContent={justify}
            >
              {children}
            </Box>
          </AccordionPanel>
        </AccordionItem>
      </Accordion>
    </Box>
  );
};

InfoCardAccordion.propTypes = {
  title: PropTypes.string.isRequired,
  flex: PropTypes.string,
  justify: PropTypes.string,
  align: PropTypes.string,
};

InfoCardAccordion.defaultProps = {
  title: "Basic Information",
  flex: "column",
};

export default InfoCardAccordion;
